import { Ceil } from "@pdfking/math"

import type { ImpositionFill } from "#internal"

/** The sheets a component's fills come to for `quantity` copies, the way the
 * backend works them out (prepress `_fill_sheets`): job by job, then the stock. */
export const FillSheets = (quantity: number, fill: ImpositionFill) => {
  let current = quantity
  const jobs = fill.jobs.map(molt => (current = Ceil(current / molt)))
  return { jobs, sheets: Ceil(current / fill.fill_molt) }
}
